import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import config from 'app/config';

const url = `${config.get('CREATE_JOBS_API_HOST')}/v1/media`;

export default Query.define('mediafile/read', {
  cache: false,

  execute: episodeId =>
    new Promise((resolve, reject) => {
      request
        .get(url)
        .query({ episodeId, sort: '-modified', limit: 1 })
        .set('Authorization', `Bearer ${getUserToken()}`)
        .end((err, res) => {
          if (err || !res.ok) {
            reject(err || new Error(`Request completed with code ${res.code}`));
          } else {
            resolve(res.body);
          }
        });
    }),
});
